.Code {
  background-color: var(--color-background-code);
  color: var(--color-default);
  display: inline-block;
  white-space: pre;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
}

.ListItem[data-type="code"] .Link {
  font-family: monospace;
}

.Link {
  display: inline-flex;
  align-items: center;
  gap: 0.5ch;
  text-decoration: none;
}
.Link:hover {
  text-decoration: underline;
}
